import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';

export interface BiConsultarResponse {
  data: {
    code: number;
    message: string;
    data: {
      id_number: string;
      first_name: string;
      last_name: string;
      gender_name: string;
      birth_date: string;
      father_first_name: string;
      father_last_name: string;
      mother_first_name: string;
      mother_last_name: string;
      marital_status_name: string;
      birth_province_name: string | null;
      birth_municipality_name: string | null;
      issue_date: string | null;
      expiry_date: string | null;
      issue_place: string | null;
      residence_country_name: string | null;
      residence_province_name: string | null;
      residence_municipality_name: string | null;
      residence_commune_name: string | null;
      residence_neighbor: string | null;
      residence_address: string | null;
    };
  };
  retorno: {
    codigo: number;
    mensagem: string;
  };
}

@Injectable({ providedIn: 'root' })
export class BiService {
  private readonly baseUrl = environment.apiserviceIMAUrl.replace(/\/$/, '');

  constructor(private http: HttpClient) {}

  consultar(bi: string): Observable<BiConsultarResponse> {
    const params = new HttpParams().set('bi', (bi || '').trim());
    return this.http.get<BiConsultarResponse>(`${this.baseUrl}/bi/consultar`, { params });
  }
}
